import * as ax from "../instrance";
import config from "../../../config/config.js";
var URL = config.apiUrl;

// 获取轮播图列表数据
export const getBannerList = params => {
  return ax.pJson(URL + "/back/xxptsz/getBannerList", params);
};

//轮播图新增
export const addBanner = params => {
  return ax.pJson(URL + "/back/xxptsz/addBanner", params);
};

//轮播图详情
export const getBannerXq = params => {
  return ax.pJson(URL + "/back/xxptsz/getBannerXq", params);
};

//修改轮播图
export const updateBanner = params => {
  return ax.pJson(URL + "/back/xxptsz/updateBanner", params);
};

//删除轮播图
export const deleteBanner = params => {
  return ax.pJson(URL + "/back/xxptsz/deleteBanner", params);
};




// WEBPACK FOOTER //
// ./src/api/xxptszApi/lbtszAx.js